module.exports = __webpack_public_path__ + "static/thumb-construction-api-48371a64831cbe22bf9b86e209abfb85.png";